import {ReactElement} from 'react';
import {Stack} from '@mantine/core';
import {DataTableColumn} from 'mantine-datatable';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';

import {usePersonas} from '../hooks/usePersonas.ts';
import {usePersonasPaging} from '../hooks/usePersonasPaging.ts';
import {usePersonasSearch} from '../hooks/usePersonasSearch.ts';
import {usePersonasSelection} from '../hooks/usePersonasSelection.ts';
import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../../config/rbac/actions.ts';
import {Persona} from '../types.ts';

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions();

    const {
        columns,
        visibleItems: records,
        loading,
    } = usePersonas();

    const {
        page,
        limit,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = usePersonasPaging(records.length);

    // Same store instance the list hook filters on (FNP-815).
    const {handleFilterByKeyword} = usePersonasSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection,
    } = usePersonasSelection();

    let selectedRecords: Persona[] = [];
    if (allowedActions.includes(rbacActions.DeleteTestingPersona)) {
        selectedRecords = records.filter(record => selection[record.id] === true);
    }

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />

            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                totalRecords={totalCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    (items as Persona[]).forEach(item => {
                        handleRowSelection(item.id, true);
                    });
                }}
                fetching={loading}
            />
        </Stack>
    );
};
